import React from 'react';

import { apiClient } from '../../graphql/api/apiClient';
import { UserActivityInterval, useuserActivityQuery } from '../../graphql/api/generated';
import { displayErrorMessage } from '../../utils';

import UserActivityChart from './UserActivityChart';

interface IUserActivityHourIntervalProps {
  startDate: string;
  endDate: string;
  propertyId: string;
  roleIds: string[];
}

const UserActivityHourInterval = React.memo((props: IUserActivityHourIntervalProps) => {
  const { startDate, endDate, propertyId, roleIds } = props;

  const { data, loading } = useuserActivityQuery({
    client: apiClient,
    fetchPolicy: 'cache-first',
    skip: !propertyId,
    variables: {
      input: {
        startDate,
        endDate,
        roleIds,
        propertyId: props.propertyId as string,
        interval: UserActivityInterval.HOUR,
      },
    },
    onError: error => displayErrorMessage(error),
  });

  const userActivity = data?.userActivity || [];

  return (
    <UserActivityChart
      startDate={startDate}
      loading={loading}
      userActivity={userActivity}
    />
  );
});

export default UserActivityHourInterval;
